/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDOCUMENTTYPE } from './IAPDOCUMENTTYPE';
import {
    IAPDOCUMENTTYPEFromJSON,
    IAPDOCUMENTTYPEFromJSONTyped,
    IAPDOCUMENTTYPEToJSON,
} from './IAPDOCUMENTTYPE';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface ProductDocumentViewModel
 */
export interface ProductDocumentViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductDocumentViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDocumentViewModel
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDocumentViewModel
     */
    documentName: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductDocumentViewModel
     */
    contentManagerDateUploaded?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProductDocumentViewModel
     */
    contentManagerFileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDocumentViewModel
     */
    contentManagerItemId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDocumentViewModel
     */
    isSelectedForSigning?: boolean;
    /**
     * 
     * @type {IAPDOCUMENTTYPE}
     * @memberof ProductDocumentViewModel
     */
    documentTypeId?: IAPDOCUMENTTYPE;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof ProductDocumentViewModel
     */
    mimeTypeId?: IAPMIMETYPE;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDocumentViewModel
     */
    isGenerated?: boolean;
}

/**
 * Check if a given object implements the ProductDocumentViewModel interface.
 */
export function instanceOfProductDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "documentName" in value;

    return isInstance;
}

export function ProductDocumentViewModelFromJSON(json: any): ProductDocumentViewModel {
    return ProductDocumentViewModelFromJSONTyped(json, false);
}

export function ProductDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'productId': json['ProductId'],
        'documentName': json['DocumentName'],
        'contentManagerDateUploaded': !exists(json, 'ContentManagerDateUploaded') ? undefined : (new Date(json['ContentManagerDateUploaded'])),
        'contentManagerFileSize': !exists(json, 'ContentManagerFileSize') ? undefined : json['ContentManagerFileSize'],
        'contentManagerItemId': !exists(json, 'ContentManagerItemId') ? undefined : json['ContentManagerItemId'],
        'isSelectedForSigning': !exists(json, 'IsSelectedForSigning') ? undefined : json['IsSelectedForSigning'],
        'documentTypeId': !exists(json, 'DocumentTypeId') ? undefined : IAPDOCUMENTTYPEFromJSON(json['DocumentTypeId']),
        'mimeTypeId': !exists(json, 'MimeTypeId') ? undefined : IAPMIMETYPEFromJSON(json['MimeTypeId']),
        'isGenerated': !exists(json, 'IsGenerated') ? undefined : json['IsGenerated'],
    };
}

export function ProductDocumentViewModelToJSON(value?: ProductDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductId': value.productId,
        'DocumentName': value.documentName,
        'ContentManagerDateUploaded': value.contentManagerDateUploaded === undefined ? undefined : (value.contentManagerDateUploaded.toISOString()),
        'ContentManagerFileSize': value.contentManagerFileSize,
        'ContentManagerItemId': value.contentManagerItemId,
        'IsSelectedForSigning': value.isSelectedForSigning,
        'DocumentTypeId': IAPDOCUMENTTYPEToJSON(value.documentTypeId),
        'MimeTypeId': IAPMIMETYPEToJSON(value.mimeTypeId),
        'IsGenerated': value.isGenerated,
    };
}

